<template>
  <div class="userinfo">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" />
    <form-entity :model="user" :rule="rule" class="form-edit">
      <form-field
        prop="nickname"
        :default-focus="false"
        :options="{
          label: '用户昵称',
          readonly: true,
          placeholder: '用户昵称',
          type: 'text',
          required: true
        }"
      />
      <form-field
        prop="userID"
        :default-focus="false"
        :options="{
          label: '用户ID',
          readonly: true,
          placeholder: '用户ID',
          type: 'text',
          required: true
        }"
      />
      <form-field
        prop="mobileNumber"
        :options="{
          label: '手机号码',
          readonly: true,
          placeholder: '手机号码',
          type: 'tel',
          format: 'phone',
          required: true
        }"
      />
    </form-entity>
    <!-- 合并账号提示 -->
    <!-- {{info}} -->
    <img class="qrcode" :src="info.data.adviser.erCode || ''" alt="" />
    <h5>{{ info.message }}</h5>
  </div>
</template>

<script>
import { storage } from '@/utils'
// import { mapGetters } from 'vuex'
export default {
  name: 'accountError',
  data() {
    return {
      title: '账号异常',
      type: null,
      rule: {},
      info: {
        message: '',
        data: {
          userModel: {},
          adviser: {
            avatarUrl: ''
          }
        }
      }
    }
  },
  computed: {
    user() {
      return this.info?.data?.userModel || {}
    }
  },
  created() {
    const info = storage.AccountErrorInfo().getItem()
    if (info) this.info = info
  },
  mounted() {
    document.title = '账户异常'
  }
}
</script>

<style lang="scss" scoped>
.qrcode {
  width: 2.8rem;
  height: 2.8rem;
  background: #ccc;
  display: block;
  margin: 1.6rem auto 0 auto;
  border: 1px solid #dddddd;
}
h5 {
  width: 100%;
  text-align: center;
  font-size: 0.28rem;
  font-weight: 600;
  color: #00b25a;
  line-height: 0.34rem;
  margin: 0.24rem 0 0.16rem 0;
}
p {
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
  line-height: 0.3rem;
  width: 100%;
  text-align: center;
}
.btns_box {
  width: 100%;
  margin-top: 10px;
  justify-content: space-around;
}
</style>
